<template>
    <v-panel>
        <v-tabs :tabs="tabs" :selected="$route.path" @click="$router.push($event)"/>
    </v-panel>
</template>
<script>
    export default {
        name: 'navigation-tabs',
        props: {
            tabs: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// NavigationTabs.vue?cb32d4d0